import ReportDataTable from "./ReportDataTable";
import { ReportRow } from "../types";

const MaintenanceReport = ({ rows }: { rows: ReportRow[] }) => (
  <ReportDataTable rows={rows} emptyMessage="No maintenance report data found." />
);

export default MaintenanceReport;
